import React from 'react';
import HealthcareApps from "./HealthcareApps";
import PageHeader from "../components/PageHeader"

const Healthcare = () => {
  return (
    <div>
        <PageHeader/>
        <HealthcareApps/>
    </div>          
  );
};

export default Healthcare;
